module.exports = __webpack_public_path__ + "static/media/zoleWon_1000_2500.dba3208b.png";